<template>
  <div>
    <Drawer
      title="编辑目录"
      v-model="menuFormModal"
      width="550"
      :mask-closable="true"
      @on-close="menuFormModal=false"
    >
      <div>
        <Form
          ref="menuForm"
          :model="menuForm"
          :label-width="120"
          :rules="menuFormRuleValidate"
        >
          <FormItem label="展示名称" prop="title">
            <Input v-model="menuForm.title" placeholder="例如：主页" clearable></Input>
          </FormItem>
          <FormItem label="路由标识" prop="name">
            <Input v-model="menuForm.name" placeholder="例如：home" clearable></Input>
          </FormItem>
          <FormItem label="链接" prop="url">
            <label>
              <Input v-model="menuForm.url" clearable></Input>
            </label>
          </FormItem>
          <FormItem label="是否显示" prop="show_in_menu">
            <i-switch size="large" v-model="menuForm.show_in_menu">
              <span slot="open">显示</span>
              <span slot="close">隐藏</span>
            </i-switch>
          </FormItem>
          <FormItem label="是否扫码登录才可见" prop="is_code">
            <i-switch size="large" v-model="menuForm.is_code">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="是否缓存" prop="not_cache">
            <i-switch size="large" v-model="menuForm.not_cache">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="组件地址" prop="file">
            <label>
              <Input v-model="menuForm.file" clearable placeholder="@表示根目录"></Input>
            </label>
          </FormItem>
          <FormItem label="重定向" prop="redirect">
            <label>
              <Input v-model="menuForm.redirect" placeholder="默认重定向至404页面"></Input>
            </label>
          </FormItem>
          <FormItem label="图标" prop="icon">
            <label>
              <Input v-model="menuForm.icon"></Input>
            </label>
          </FormItem>
          <FormItem label="排序" prop="order">
            <label>
              <InputNumber :max="100" :min="1" v-model="menuForm.order" style="width:100%"></InputNumber>
            </label>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="handleSubmit">提交</Button>
            <Button style="margin-left: 8px" @click="menuFormModal=false">取消</Button>
          </FormItem>
        </Form>
      </div>
    </Drawer>
    <Card>
      <Tree :data="dataTree" :render="renderContent" show-checkbox multiple style="padding-right:10px"></Tree>
    </Card>
    <Modal
      v-model="iconModal"
      title="请选择图标样式"
    >
      <Icons @copyIcon="getIcon"></Icons>
    </Modal>
  </div>
</template>

<script>
import { getMenu, updateMenu, deleteMenu, createMenu } from '@/api/user'
import Icons from '@/view/user-manage/menu-icon'
export default {
  name: 'menu-manage',
  components: {
    Icons
  },
  data () {
    return {
      iconModal: false,
      menuFormModal: false,
      dataTree: [
        {
          title: '后台菜单',
          expand: true,
          render: (h, { root, node, data }) => {
            return h('span', {
              style: {
                display: 'inline-block',
                width: '100%'
              }
            }, [
              h('span', [
                h('Icon', {
                  props: {
                    type: 'ios-folder-outline'
                  },
                  style: {
                    marginRight: '8px'
                  }
                }),
                h('span', data.title, {
                  style: {
                    display: 'inline-block',
                    width: '100%'
                  }
                })
              ]),
              h('span', {
                style: {
                  display: 'inline-block',
                  float: 'right',
                  marginRight: '32px'
                }
              }, [
                h('Button', {
                  props: Object.assign({}, this.buttonProps, {
                    icon: 'md-add',
                    type: 'primary'
                  }),
                  style: {
                    width: '64px'
                  },
                  on: {
                    click: () => {
                      this.append(data)
                    }
                  }
                })
              ])
            ])
          },
          children: []
        }
      ],
      menuForm: {
        title: '',
        name: '',
        order: 1,
        url: '',
        icon: '',
        parent: 0,
        id: 0,
        file: '',
        redirect: '',
        show_in_menu: true,
        not_cache: true
      },
      buttonProps: {
        type: 'default',
        size: 'small'
      },
      menuFormRuleValidate: {
        title: [{ required: true, message: '实际显示菜单名称不能为空' }],
        name: [{ required: true, message: '路由唯一标识不能为空' }],
        url: [{ required: true, message: '路由链接不能为空', trigger: 'blur' }],
        file: [{ required: true, message: '组件地址不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$refs['menuForm'].validate(valid => {
        if (valid) {
          if (!this.menuForm.id) {
            createMenu(this.menuForm).then(res => {
              if (res.status === 201) {
                this.$Notice.success({ title: '操作成功！' })
                this.formReset()
                this.getMenu()
                this.menuFormModal = false
              } else {
                this.$Notice.error({
                  title: '操作失败！ 错误状态码:' + res.status,
                  desc: res.msg
                })
              }
            }).catch(res => {
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          } else {
            updateMenu(this.menuForm, this.menuForm.id).then(res => {
              if (res.status === 200) {
                this.$Notice.success({ title: '操作成功！' })
                this.formReset()
                this.getMenu()
                this.menuFormModal = false
              } else {
                this.$Notice.error({
                  title: '操作失败！ 错误状态码:' + res.status,
                  desc: res.msg
                })
              }
            }).catch(res => {
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          }
        } else {
          this.$Notice.error({ title: '请检查输入内容！' })
        }
      })
    },
    getIcon (icon) {
      this.menuForm.icon = icon
      this.iconModal = false
    },
    renderContent (h, { root, node, data }) {
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%',
          paddingTop: '4px'
        }
      }, [
        h('span', [
          h('Icon', {
            props: {
              type: ''
            },
            style: {
              marginRight: '8px'
            }
          }),
          h('span', {
            on: {
              'click': () => {
                this.edit(data)
              }
            },
            style: { 'cursor': 'pointer' }
          }, data.title)
        ]),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '32px'
          }
        }, [
          h('Button', {
            props: Object.assign({}, this.buttonProps, {
              icon: 'md-add'
            }),
            style: {
              marginRight: '8px'
            },
            on: {
              click: () => {
                this.append(data)
              }
            }
          }),
          h('Poptip',
            {
              props: {
                confirm: true,
                placement: 'bottom',
                title: '你确定要删除吗?'
              },
              on: {
                'on-ok': () => {
                  this.remove(root, node, data)
                }
              }
            },
            [
              h(
                'Button',
                {
                  props: Object.assign({}, this.buttonProps, {
                    icon: 'md-remove'
                  })
                }
              )
            ])
        ])
      ])
    },
    append (data) {
      const children = data.children || []
      children.push({
        title: '新菜单',
        expand: true,
        parent: data.id
      })
      this.$set(data, 'children', children)
    },
    remove (root, node, data) {
      const parentKey = root.find(el => el === node).parent
      const parent = root.find(el => el.nodeKey === parentKey).node
      const index = parent.children.indexOf(data)
      parent.children.splice(index, 1)
      if (data.id) {
        deleteMenu(data.id).then(res => {
          if (res.status === 204) {
            this.$Notice.success({ title: '操作成功！' })
            this.formReset()
            this.getMenu()
          } else {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.status,
              desc: res.msg
            })
          }
        }).catch(res => {
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      }
    },
    formReset () {
      this.menuForm.title = ''
      this.menuForm.name = ''
      this.menuForm.url = ''
      this.menuForm.show_in_menu = true
      this.menuForm.not_cache = true
      this.menuForm.file = ''
      this.menuForm.redirect = ''
      this.menuForm.icon = ''
      this.menuForm.id = 0
      this.menuForm.parent = 0
    },
    edit (data) {
      this.menuForm.title = data.title
      this.menuForm.name = data.name
      this.menuForm.icon = data.icon
      this.menuForm.url = data.url
      this.menuForm.file = data.file
      this.menuForm.show_in_menu = !!data.show_in_menu
      this.menuForm.not_cache = !!data.not_cache
      this.menuForm.id = data.id
      this.menuForm.parent = data.parent
      this.menuFormModal = true
    },
    toTree (data) {
      // 删除 所有 children,以防止多次调用
      data.forEach(function (item) {
        delete item.children
      })

      // 将数据存储为 以 id 为 KEY 的 map 索引数据列
      var map = {}
      data.forEach(function (item) {
        map[item.id] = item
      })
      var val = []
      data.forEach(function (item) {
        // 以当前遍历项，的pid,去map对象中找到索引的id
        var parent = map[item.parent]
        // 好绕啊，如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
        if (parent) {
          (parent.children || (parent.children = [])).push(item)
        } else {
          // 如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
          val.push(item)
        }
      })
      return val
    },
    getMenu () {
      getMenu().then(res => {
        let arr = res.data
        arr = this.toTree(arr)
        this.dataTree[0].children = arr
      })
    }
  },
  mounted: function () {
    this.getMenu()
  }
}
</script>

<style scoped>
</style>
